import React, { useState, useEffect } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from './ui/dialog';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Label } from './ui/label';
import { AlertTriangle } from 'lucide-react';

// Danger-zone guard: the user must type an exact phrase (usually the staff
// member's name) before a destructive action runs.
export function ConfirmByTyping({ open, onOpenChange, title, description, confirmWord, actionLabel, onConfirm }) {
  const [typed, setTyped] = useState('');

  useEffect(() => { if (open) setTyped(''); }, [open, confirmWord]);

  const matches = typed.trim().toLowerCase() === String(confirmWord || '').trim().toLowerCase();

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="confirm-by-typing-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 text-red-700">
            <AlertTriangle className="w-5 h-5" /> {title}
          </DialogTitle>
          <DialogDescription>{description}</DialogDescription>
        </DialogHeader>
        <div className="space-y-2">
          <Label>
            Type <span className="font-semibold text-slate-900 dark:text-slate-100">{confirmWord}</span> to confirm
          </Label>
          <Input
            value={typed}
            onChange={(e) => setTyped(e.target.value)}
            placeholder={confirmWord}
            autoFocus
            data-testid="confirm-by-typing-input"
          />
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)} data-testid="confirm-by-typing-cancel">
            Cancel
          </Button>
          <Button
            variant="destructive"
            disabled={!matches}
            onClick={onConfirm}
            data-testid="confirm-by-typing-submit"
          >
            {actionLabel}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
